export default __webpack_public_path__ + "static/media/grafema_clivitalbio_04.0e27d93b.jpg";